function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconCouple = function IconCouple(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "77",
    height: "100",
    viewBox: "0 0 77 100",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3732_10791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6477 24.9997C28.9016 24.9997 33.9713 19.9121 33.9713 13.6361C33.9713 7.36013 28.9016 2.27246 22.6477 2.27246C16.3939 2.27246 11.3242 7.36013 11.3242 13.6361C11.3242 19.9121 16.3939 24.9997 22.6477 24.9997Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9403 99.9996V86.3632C71.6997 86.3632 74.7344 83.3177 74.7344 79.545V56.8177C74.7344 50.545 69.6614 45.4541 63.4108 45.4541H47.5579C41.3073 45.4541 36.2344 50.545 36.2344 56.8177V79.545C36.2344 83.3177 39.2691 86.3632 43.0285 86.3632V99.9996",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4861 36.3637C61.1145 36.3637 65.6773 31.7848 65.6773 26.1365C65.6773 20.4881 61.1145 15.9092 55.4861 15.9092C49.8577 15.9092 45.2949 20.4881 45.2949 26.1365C45.2949 31.7848 49.8577 36.3637 55.4861 36.3637Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9624 46.4317C42.3056 39.4999 36.508 34.0908 29.4421 34.0908H15.8539C8.35768 34.0908 2.26562 40.2045 2.26562 47.7272V74.9999C2.26562 78.7726 5.30033 81.8181 9.05974 81.8181V99.9999",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3732_10791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "77",
    height: "100",
    fill: "white"
  }))));
};